/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "lambdaApi",
            "endpoint": "https://qoyew04qfl.execute-api.us-west-2.amazonaws.com/prod",
            "region": "us-west-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://xns22gz5qfeb7j6zsm2nvh4juy.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-klzvqvwucbgfbeo3y6kyyjsju4",
    "aws_cognito_identity_pool_id": "us-west-2:79c3fe91-96f4-476b-a21e-8bb1b3426eab",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_dII8VOILi",
    "aws_user_pools_web_client_id": "2u7jeq64sb02mhs1n0efsuofe5",
    "oauth": {
        "domain": "scouted268ba6c4-268ba6c4-prod.auth.us-west-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://scouted.com,https://testing.dinhij4ec0rxz.amplifyapp.com,http://localhost:3000",
        "redirectSignOut": "https://scouted.com,https://testing.dinhij4ec0rxz.amplifyapp.com,http://localhost:3000",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "scoutedpwa82d3111cbb4c40dcae02ab31a95a9c2b100940-prod",
    "aws_user_files_s3_bucket_region": "us-west-2"
};


export default awsmobile;
